import React from "react";

export default function DropDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.04078 5.87415C3.3174 5.59753 3.76589 5.59753 4.04251 5.87415L8.49998 10.3316L12.9574 5.87415C13.2341 5.59753 13.6826 5.59753 13.9592 5.87415C14.2358 6.15077 14.2358 6.59927 13.9592 6.87589L9.00085 11.8342C8.72423 12.1108 8.27573 12.1108 7.99911 11.8342L3.04078 6.87589C2.76416 6.59927 2.76416 6.15077 3.04078 5.87415Z"
        fill="#343434"
      />
    </svg>
  );
}
